import React from 'react';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../theme/colors';

const useProminentTooltipStyles = makeStyles({
  tooltip: {
    backgroundColor: colors.principal.blue,
    color: '#FFFFFF',
    fontWeight: 900,
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    padding: '10px 14px',
    maxWidth: 300,
    boxShadow: '0 4px 12px rgba(0, 49, 83, 0.35)',
  },
  arrow: {
    color: colors.principal.blue,
  },
});

const PlanFeatureTooltip = ({ title, children, prominent = false }) => {
  const classes = useProminentTooltipStyles();

  if (!prominent) {
    return <Tooltip title={title}>{children}</Tooltip>;
  }

  return (
    <Tooltip
      title={title}
      arrow
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
    >
      {children}
    </Tooltip>
  );
};

export default PlanFeatureTooltip;
